import { crud } from '@think-internet/zeus-frontend-package'

const props = {
  ...crud.Features,

  // admin features
  COMPANY: 'COMPANY',
  MEMBER: 'MEMBER',
  INVOICE: 'INVOICE',
  MESSAGE: 'MESSAGE',
  HDG_DATA: 'HDG_DATA',
  EVENT: 'EVENT',
  EMPLOYEE: 'EMPLOYEE',
  EVENT_ATTENDANCE: 'EVENT_ATTENDANCE',
  EVENT_ATTENDANCE_TOGGLE: 'EVENT_ATTENDANCE_TOGGLE',
  BANKING_TRANSACTION: 'BANKING_TRANSACTION',
  MAIL_SCHEDULE: 'MAIL_SCHEDULE',
  CERTIFICATE: 'CERTIFICATE',
  CARRIER: 'CARRIER',
  TEAM: 'TEAM',
  TEAM_MEMBER: 'TEAM_MEMBER',
  ORDER: 'ORDER',
}

export default props
